'use client'
import React, { useMemo } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { ArrowCircleUpRight } from '@phosphor-icons/react'
import Bulb from 'public/images/support/Bulb.png'
import FeatureSugesstionDialog from './sub-components/FeatureSugesstionDialog'
import { useSupportPageContext } from 'src/lib/contexts/SupportPageContext'
import FeatureList from './sub-components/FeatureList'
import useSWR from 'swr'
import { apiURI } from 'src/lib/utils/constants'
import { getRequest, staticOptions } from 'src/lib/core/api-client'
import { defaultFeatureSuggestionState, normalizeFeebackResponse } from 'src/lib/utils/support'
import { BackendFeedbackResponse, FeedbackReponseType } from 'src/lib/types/support'
import ViewFeatureDialog from './sub-components/ViewFeatureDialog'
import DeleteTicketDialog from './sub-components/DeleteTicketDialog'
import SupportPageHeader from './sub-components/SupportPageHeader'

const SupportPage = () => {
  const {
    data: feedbackResponse,
    error,
    isLoading,
    mutate: mutateSuggestion,
    isValidating
  } = useSWR(['/feedback', apiURI.SETTLEMENT_ENGINE], ([url, baseURI]) => getRequest(url, baseURI), staticOptions)

  const normalizedFeebackResponse: FeedbackReponseType[] = useMemo(() => {
    if (feedbackResponse?.data) {
      const data: any = feedbackResponse.data
      return normalizeFeebackResponse(data.data as BackendFeedbackResponse[])
    }
    return []
  }, [feedbackResponse])

  return (
    <div className='flex flex-col gap-8 p-8'>
      <SupportPageHeader />
      <FeatureSuggestion />
      <FeatureList
        normalizedFeebackResponse={normalizedFeebackResponse}
        mutateSuggestion={mutateSuggestion}
        isLoading={isLoading || isValidating}
      />
      <FeatureSugesstionDialog />
      <ViewFeatureDialog />
      <DeleteTicketDialog mutateSuggestion={mutateSuggestion} />
    </div>
  )
}

export default SupportPage

export const FeatureSuggestion = () => {
  const { t } = useLocale()
  const {
    actions: { handleFeatureSuggestionDialog, handleFeatureSuggestion }
  } = useSupportPageContext()

  const handleOpenNewFeatureDialog = () => {
    handleFeatureSuggestion(defaultFeatureSuggestionState)
    handleFeatureSuggestionDialog(true)
  }
  return (
    <div className='rounded-md flex flex-col gap-4'>
      <div className='flex gap-2'>
        <h3 className='text-gray-dark font-semibold'>{t('support.feature_suggestion')}</h3>
        <div className='flex bg-green-light w-fit py-[0px] px-3 text-white rounded-xl text-[10px] items-center'>
          {t('new')}
        </div>
      </div>
      <div
        id='feature-suggestion-block'
        className='bg-gray-lightest py-6 px-4 rounded-t-xl flex justify-between border-b-1 gap-4'
      >
        <div className='flex flex-col gap-2'>
          <h3 className='text-coal-dark font-medium text-[18px]'>{t('support.feature_suggestion_title')}</h3>
          <h4 className='text-gray-dark font-medium text-base'>{t('support.feature_suggestion_description')}</h4>
        </div>
        <div
          id='suggest-new-feature'
          className='flex items-center justify-center bg-carbon gap-4 rounded-xl h-12 px-4 py-3 cursor-pointer min-w-72 '
          onClick={handleOpenNewFeatureDialog}
        >
          <img src={Bulb.src} alt='Bulb Icon' width={24} height={24} />
          <span className='text-white'>{t('support.suggest_new_feature')}</span>
          <ArrowCircleUpRight size={24} color='#FFFFFF' />
        </div>
      </div>
    </div>
  )
}
